<template>
    <div class="minisite-privacy">
        <template-00
            v-if="data.style && data.style.templateId && data.style.templateId === '00'"
            :data="data"
            @privacy-cancel="$emit('privacy-cancel')"
            @privacy-confirm="$emit('privacy-confirm')"></template-00>
    </div>
</template>

<script>
    import PrivacyComponent from "./privacy"
    import CommonMixIn from "./common.mixin"

    export default {
        name: "Privacy",
        mixins: [CommonMixIn],
        components: {
            "template-00": PrivacyComponent.Template00
        },
        props: {
            data: {}
        },
        computed: {
            getListStyle() {
                if (this.data.style && this.data.style.background) {
                    return Object.assign({}, this.data.style.background, {
                        ...this.getPadding(this.data.style.background.padding),
                        ...this.getMargin(this.data.style.background.margin)
                    })
                }
                return {}
            }
        }
    }
</script>

<style lang="less">
    .minisite-text-list {
        width: 100%;

        .js_img_loading {
            .img_loading {
                display: none;
            }
        }

        mpvideosnap {
            display: none;
        }
    }
</style>
